import { createOpenSNSocialApp, mountOpenSNSignupForm } from "opensn/react";
import { resolveSocialView } from "./social-contracts";
import { socialDefinition } from "./opensn/social-definition";

const registrationForm = document.querySelector<HTMLElement>("[data-registration-form]");

if (registrationForm) {
  const localeCode = document.documentElement.lang;
  fetch(`/assets/registration/${localeCode}.json`)
    .then(async (response) => {
      if (!response.ok) throw new Error(String(response.status));
      mountOpenSNSignupForm(registrationForm, {
        dictionary: await response.json(),
        localeCode,
        view: resolveSocialView("/signup")!,
        currentQuery: { ...Object.fromEntries(new URLSearchParams(window.location.search)), lang: localeCode },
        socialDefinition
      });
    })
    .catch(() => {
      registrationForm.textContent = registrationForm.dataset.error!;
      registrationForm.setAttribute("role", "alert");
    });
} else {
  createOpenSNSocialApp({ resolveView: resolveSocialView });
}
